// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { postWrapper } from "helpers/api";

export const postSubmitMailingListExportJob = (body) =>
  postWrapper("/mailing-list-exports", body);
